module.exports = __webpack_public_path__ + "static/media/print4.0f9ea615.jpg";